import { useQuery } from '@tanstack/react-query';

import type { ObtainMethod } from '@frontend/api';
import { useRequest, type QueryFunction } from '@frontend/api/src/common';

export type AssemblyTreeNodeData = {
  componentId: number;
  count: number;
  filename: string;
  nodeId: number;
  id: string;
  partNumber: null | string;
  revision: null | string;
  description: null | string;
  primaryFileUuid: string;
  obtainMethod: ObtainMethod;
  isAssembly: boolean;
  workflowStatus: string;
  children: AssemblyTreeNodeData[];
};

export type AssemblyTreeResponse = {
  root: AssemblyTreeNodeData;
  componentCount: number;
};

type UseGetAssemblyTreeParams = {
  quoteItemId: number;
};

export type GetAssemblyTreeQueryKeyType = readonly [
  'quoteItemAssemblyTree',
  number,
];

export const getAssemblyTreeQueryKey = (
  params: UseGetAssemblyTreeParams,
): GetAssemblyTreeQueryKeyType => ['quoteItemAssemblyTree', params.quoteItemId];

export const useGetAssemblyTree: QueryFunction<
  AssemblyTreeResponse,
  [UseGetAssemblyTreeParams],
  GetAssemblyTreeQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getAssemblyTreeQueryKey(params);

  return useQuery<
    AssemblyTreeResponse,
    unknown,
    AssemblyTreeResponse,
    GetAssemblyTreeQueryKeyType
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/quotes/items/${params.quoteItemId}/assembly_tree/`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
